import { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import Container from 'react-bootstrap/Container'
import Header from '../Components/Header/Header'
import { backendAccessPost, backendAccessGet, backendMe, logout } from '../Utils/Authentication'
import Modal from 'react-bootstrap/Modal'
import Loading from '../Components/UserHome/Loading'
import WidgetBrowser from '../Components/WidgetBrowser/WidgetBrowser'
import InputGroup from 'react-bootstrap/InputGroup'
import Form from 'react-bootstrap/Form'
import Button from '@mui/material/Button'


import ReactMarkdown from 'react-markdown'
import tosFrPath from '../Legal/tos20240614.md'

export function ShareWidgetModal( props )
{
    const showModal = props.showModal 
    const setShowModal = props.setShowModal
    const widgetId = props.widgetId

    const [ sharedList, setSharedList ] = useState([])
    const [ shareUserId, setShareUserId ] = useState("")

    const reload = () => {
        let data = {}
        data.widget_id = widgetId.current

        backendAccessPost('/api/widgets/shared-instances/', data).then( res => {
            if( res.error_message )
            {
                alert( res.error_message )
                return 
            }

            
            setSharedList( res.shared_instances )
        })


    }

    useEffect( () => {
        if(!showModal)
        {
            return
        }
        reload()
        setShareUserId("")
    },[showModal] )

    const shareWidget = () => {
        if( shareUserId == "" )
        {
            return
        }

        let data = {}
        data['widget_id'] = widgetId.current 
        data['user_id'] = shareUserId

        backendAccessPost('/api/widgets/share-widget/', data).then( res => {
            if( res.error_message )
            {
                alert( res.error_message )
                return 
            }

            setSharedList( res.shared_instances )
            setShareUserId("")
        })
    }

    const revoke = ( user_id ) => {
        var data = {}
        data['user_id'] = user_id 
        data['widget_id'] = widgetId.current 

        backendAccessPost('/api/widgets/revoke-share-widget/', data).then( res => {
            if( res.error_message )
            {
                alert( res.error_message )
                return 
            }
            
            setSharedList( res.shared_instances )
        })
    }

    return (
        <Modal show={showModal} onHide={e => setShowModal(false)}>
            <Modal.Header>
                Share widget
            </Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom:'10px'}}>
                    <InputGroup size="sm">
                        <Form.Control value={shareUserId}
                                      onChange={ e => setShareUserId(e.target.value)}
                        />
                        <Button onClick={shareWidget}>Share</Button>
                    </InputGroup>
                </div>
                <div>
                    { sharedList.map( (user_id,idx) => 
                    <div>{user_id} [<a href="#" onClick={ e => revoke(user_id)}>Remove</a>]</div>
                    )}
                </div>
            
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    )
}

export default function WidgetBrowserPage( props )
{
    const me = props.me 
    const setMe = props.setMe
    const accounts = props.accounts 
    const setAccounts = props.setAccounts 
    const displayName = props.displayName 
    const setDiplayName = props.setDiplayName 
    const avatarImage = props.avatarImage 
    const setAvatarImage = props.setAvatarImage

    const userState = props.userState 
    const setUserState = props.setUserState 
    const userConfig = props.userConfig 
    const setUserConfig = props.setUserConfig 
    const userPoints = props.userPoints 
    const setUserPoints = props.setUserPoints 
    const accountType = props.accountType 
    const setAccountType = props.setAccountType 

    const state = props.state 
    const setState = props.setState

    const navigate = useNavigate()

    const stateLock = useRef(false)
    const [futureState, setFutureState] = useState(null)

    const [ showShareModal, setShowShareModal] = useState(false)
    const shareWidgetId = useRef(null)

    useEffect( () => {
        setState("1")
    },[])

    const editWidget = ( widget_id ) => {
        navigate("/widget-editor", { state: { widget_id: widget_id } })
    }

    const shareWidget = ( widget_id ) => {
        shareWidgetId.current = widget_id
        setShowShareModal(true)
    }

    return (
        <div className="d-flex justify-content-center" style={{ width: '100%', height: '100vh' }}>
            { ( me && userState && userConfig ) &&
                <>
                <div style={{ height: '100%', width: '100%' }}>
                    <div style={{ width: '100%', height:'calc(100% - 100px)' }}>
                        <Container style={{ maxWidth: '1200px' }}>
                            <Header me={me} avatarImage={avatarImage} 
                                    state={state} setState={setState} 
                                    stateLock={stateLock} 
                                    setFutureState={setFutureState}
                                    displayName={displayName}
                                    userPoints={userPoints}
                                    setUserPoints={setUserPoints}
                                    accountType={accountType}
                                    setAccountType={setAccountType}
                                    navigate={navigate}
                            />
                        </Container> 
                        <WidgetBrowser editWidget={editWidget} 
                                       shareWidget={shareWidget}
                                       userConfig={userConfig}
                                       navigate={navigate}
                        />
                    </div>
                </div>
                <ShareWidgetModal showModal={showShareModal}
                                  setShowModal={setShowShareModal}
                                  widgetId={shareWidgetId}
                />
                </>
            }
        </div>
    )
}
